"use client";

import { Navbar } from "@/components/common/navbar";
import Topbar from "@/components/common/topbar";
import AppPromotionModal from "@/modules/home/components/app-promotion-modal";

export default function MainLayout({ children }: { children: React.ReactNode }) {
	return (
		<>
			<Topbar />
			<Navbar />
			{children}

			<AppPromotionModal />
		</>
	);
}
